import { find } from 'lodash';
import { questionAnswerSupportsMedia } from 'utils/questionHelpers';
import { getEmptyMatrixAnswer } from '../../../../GenericQuestion/MatrixQuestion/utils';

export const MATRIX_ANSWER_PROP = 'matrixAnswer';
export const MATRIX_COLUMN_PROP = 'matrixColumn';
export const isNewMatrixProp = (prop) =>
  [MATRIX_ANSWER_PROP, MATRIX_COLUMN_PROP].includes(prop);

// TODO: we need to be careful to keep only things that are relevant for matrixAnswers since the input is a regular answer
export const createCarriedMatrixAnswer = ({
  questionRefId,
  answer,
  targetType,
  changedProperty,
}) => {
  const carriedDetails = {
    questionRefId,
    isCarriedForward: true,
  };

  // keep the original answer refId if it exists
  // since we can only update an answer from the 1st instance (and the carried forward)
  carriedDetails.originalAnswerRefId =
    answer.originalAnswerRefId ||
    answer.originalScorepointRefId ||
    answer.refId;

  let newMatrixProps;
  if (changedProperty === MATRIX_COLUMN_PROP) {
    newMatrixProps = getEmptyMatrixAnswer();
  } else {
    newMatrixProps = getEmptyMatrixAnswer({ answerRefId: answer.refId });
  }

  return updateCarriedMatrixAnswer(
    {
      ...newMatrixProps,
      ...carriedDetails,
    },
    answer,
    targetType,
  );
};

// eslint-disable-next-line no-unused-vars
export const updateCarriedMatrixAnswer = (oldAnswer, newAnswer, targetType) => {
  const canHaveMedia = questionAnswerSupportsMedia(targetType);
  return {
    ...oldAnswer,
    beforeLabel: newAnswer.body,
    media: canHaveMedia ? newAnswer.media : undefined,
    hasImage: canHaveMedia ? Boolean(newAnswer.media) : false,
  };
};

export function getCarriedForwardDataForMatrixAnswer(answers, matrixAnswer) {
  const answer = find(answers, ['refId', matrixAnswer.answerRefId]);
  if (answer && answer.isCarriedForward) {
    return {
      isCarriedForward: answer.isCarriedForward,
      originalAnswerRefId: answer.originalAnswerRefId,
      // originalQuestionRefId: answer.originalQuestionRefId,
      questionRefId: answer.questionRefId,
    };
  }
  return undefined;
}
